import { ElementListItem } from '../types'

/** Case-insensitive substring search over an item's label, cross-section and assembly. */
export const filterElementListItems = (
  items: ElementListItem[],
  query: string,
): ElementListItem[] => {
  const normalized = query.trim().toLowerCase()
  if (!normalized) return items
  return items.filter(item =>
    [item.label, item.crossSectionLabel, item.assemblyName].some(field =>
      field?.toLowerCase().includes(normalized),
    ),
  )
}
